import { render, staticRenderFns } from "./CardTraffic.vue?vue&type=template&id=592bdc61"
import script from "./CardTraffic.vue?vue&type=script&lang=js"
export * from "./CardTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports